import {
	cancelCounteroffer,
	getBuyersCounteroffers,
	getBuyersCounteroffersMore,
} from 'features/secondaryMarket/actions';

import { CounterofferList } from 'componets/containers';

import { CounterofferStatus } from 'utils/constants';
import { ICounterofferItem } from 'models';
import { useAppSelector } from 'hooks';

export const SentCounteroffers = () => {
	const { buyerCounteroffers, buyerCounterofferPager: pager } = useAppSelector(
		(state) => state.secondaryMarket,
	);

	return (
		<CounterofferList
			getRows={getRows}
			pager={pager}
			items={buyerCounteroffers}
			getButtons={(item: ICounterofferItem) =>
				item.counterOffer.status === 'PENDING'
					? [
							{
								type: 'primary',
								text: 'cancelText',
								callback: cancelCounteroffer,
								id: item.counterOffer.id,
								isCancel: true,
							},
					  ]
					: []
			}
			callback={getBuyersCounteroffers}
			callbackMore={getBuyersCounteroffersMore}
			isSent
		/>
	);
};

const getRows = (item: ICounterofferItem) => [
	{
		title: 'initialInvestmentAmountText',
		value: item.sale.investment.remainingPrincipal,
	},
	{ title: 'sellersPriceText', value: item.sale.amount },
	{
		title: 'yourPriceText',
		value: item.counterOffer.amount,
	},
	{
		title: 'statusText',
		value:
			item.counterOffer.status === CounterofferStatus.PENDING
				? 'activeText'
				: item.counterOffer.status,
		isStatus: true,
	},
];
